module.exports = __webpack_public_path__ + "static/img/proben-logo.3f9c5dda.png";